import * as tslib_1 from "tslib";
import _ from 'lodash';
import { PlaceOrderUrl, GetOrdersUrl, SearchOrdersUrl, CancelOrderUrl, ChangeOrderUrl } from '../constants';
import { transformForApi, transformFromApi, transformOrderForApi } from '..';
import dayjs from 'dayjs';
const httpOptions = {
    headers: { Accept: 'application/json' },
};
export const create = (api) => {
    return (orderDesc) => {
        const order = transformForApi(orderDesc);
        return api.authenticated().post(PlaceOrderUrl, order, httpOptions);
    };
};
export const change = (api) => {
    return (orderDesc) => {
        const order = transformOrderForApi(orderDesc);
        return api.authenticated().post(ChangeOrderUrl, order, httpOptions);
    };
};
export const cancel = (api) => {
    return (orderId, accountId) => {
        // might need to pass subaccountId, clientRefId params at some point: https://devapi.tradingblock.com/swagger-ui#/Orders/CancelOrder
        const data = { orderId, accountId };
        return api.authenticated().post(CancelOrderUrl, data, httpOptions);
    };
};
const buildOrderQueryPayload = (options) => {
    const request = _.omit(options, ['blockId']);
    return _.pickBy(Object.assign({}, request, { dateFrom: request.dateFrom
            ? dayjs(request.dateFrom)
                .utc()
                .toDate()
            : undefined, dateTo: request.dateTo
            ? dayjs(request.dateTo)
                .utc()
                .toDate()
            : undefined }), (v) => v !== undefined);
};
const normalizeOrdersApiResponse = (apiResponse) => {
    return Object.assign({}, apiResponse, { payload: apiResponse.payload
            ? (() => {
                const p = apiResponse.payload;
                // Legacy API used PascalCase Items; some responses used lowercase items only for this endpoint.
                const rawList = (p.Items != null ? p.Items : p.items);
                return Object.assign({}, apiResponse.payload, { items: _.map(rawList, transformFromApi) });
            })()
            : undefined });
};
export const getOrders = (api) => {
    return (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const optionValues = buildOrderQueryPayload(options);
        const apiResponse = yield api.authenticated().get(GetOrdersUrl, optionValues, httpOptions);
        return normalizeOrdersApiResponse(apiResponse);
    });
};
export const searchOrders = (api) => {
    return (accountId, request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const body = buildOrderQueryPayload(request);
        const apiResponse = yield api
            .authenticated()
            .post(SearchOrdersUrl(accountId), body, httpOptions);
        return normalizeOrdersApiResponse(apiResponse);
    });
};
export function order(api) {
    return (accountId, subaccountId) => ({
        change: (req) => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield change(api)(req); }),
        create: (orderDesc) => tslib_1.__awaiter(this, void 0, void 0, function* () { return create(api)(Object.assign({}, orderDesc, { AccountId: accountId, kind: 'order' })); }),
        get: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () { return getOrders(api)(Object.assign({}, request, { accountId, subaccountId })); }),
        search: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () { return searchOrders(api)(accountId, Object.assign({}, request, { subaccountId })); }),
        cancel: (orderId) => tslib_1.__awaiter(this, void 0, void 0, function* () { return cancel(api)(orderId, accountId); }),
    });
}
//# sourceMappingURL=orderApi.js.map